<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>학생 가입 승인</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.search_text" @keyup.enter="retreive" placeholder="이름 / 전화번호 / 학교">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retreive">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>
    </div>

    <div class="card-body text-left">
      <el-button type="primary" @click="multiAcceptUser">승인</el-button>
      <el-button type="danger" @click="multiDeleteUser">삭제</el-button>
    </div>

    <!-- 그리드 -->
    <stone-data-table
      ref="requestUserTable"
      class="no-left-margin small-td"
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="tableProps"
      :action-col="tableActionCol"
      @selection-change="handleSelectionChange">
    </stone-data-table>

    <el-dialog :visible.sync="dialogVisible" append-to-body width="480px" title="회원 요청 정보">
      <el-form :model="frm" :rules="rules" ref="frm" label-width="130px" class="join-form">
        <el-form-item label="이름" prop="name">
          <el-input v-model.trim="frm.name" placeholder="이름"></el-input>
        </el-form-item>
        <el-form-item label="생년월일" required>
          <el-col :span="8">
            <el-form-item prop="birthday_yyyy">
              <el-select v-model="frm.birthday_yyyy" placeholder="년" >
                <el-option v-for="y in yearCount" :key="y" :label="`${y + startYear} 년`" :value="y + startYear">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="birthday_mm">
              <el-select v-model="frm.birthday_mm" placeholder="월">
                <el-option v-for="m in 12" :key="m" :label="`${m} 월`" :value="getDateValue(m)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="birthday_dd">
              <el-select v-model="frm.birthday_dd" placeholder="일">
                <el-option v-for="d in getDays" :key="d" :label="`${d} 일`" :value="getDateValue(d)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="핸드폰번호" prop="phone">
          <el-input type="tel" v-model.trim="frm.phone" placeholder="'-' 를 빼고 입력하십시오" @change="autoHypenPhone('phone')" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="클래스" prop="class_seq">
          <el-select v-model="frm.class_seq" placeholder="선택하세요." style="width: 100%;">
            <el-option v-for="item in classData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="알림 유형" prop="msg_type">
          <el-radio-group v-model="frm.msg_type" class="stone-radio-btton">
            <el-radio-button label="K">카카오톡</el-radio-button>
            <el-radio-button label="S">SMS</el-radio-button>
            <el-radio-button label="N">수신거부</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="학교" prop="school_name">
          <el-input v-model.trim="frm.school_name"></el-input>
        </el-form-item>

        <div class="text-right">
          <el-button @click="dialogVisible = false">닫기</el-button>
          <el-button type="primary" @click="submitForm('frm')">저장</el-button>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M991001',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        // {label: '번호', prop: 'seq', align: 'right', width: 40},
        {label: '이름', prop: 'name', align: 'left', class: 'no-point'},
        {label: '클래스명', prop: 'class_name', align: 'left', class: 'no-point'},
        {label: '전화번호', prop: 'phone', align: 'center', formatter: this.columnFormatterPhone, class: 'no-point'},
        {label: '학교명', prop: 'school_name', align: 'left', class: 'no-point'},
        {label: '생년월일', prop: 'birthday', align: 'center', formatter: this.columnFormatterDate, class: 'no-point'},
        {label: '알림유형', prop: 'msg_type_name', align: 'center', class: 'no-point'},
        {label: '상태', prop: 'req_stat_str', align: 'center', class: 'no-point'},
        {label: '요청일자', prop: 'req_dt', align: 'center', formatter: this.columnFormatterDate, class: 'no-point'}
      ],
      handleSelection: [],
      tableProps: {height: this.getScreenHeight(76)},
      tableActionCol: {
        label: ' ',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.goEdit(row)
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '상세'
        }]
      },
      search: {
        search_text: ''
      },
      dialogVisible: false,
      frm: {
        seq: 0,
        name: '',
        phone: '',
        school_name: '',
        birthday: '',
        birthday_yyyy: '',
        birthday_mm: '',
        birthday_dd: '',
        class_seq: '',
        msg_type: ''
      },
      yearCount: 0,
      startYear: 1980,
      classData: [],
      rules: {
        name: [
          { required: true, message: '사용자 이름을 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 10, message: '최소 2자 이상 최대 10자까지 입력하십시오.' }
        ],
        phone: [
          { required: true, message: '전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        birthday_yyyy: [
          { required: true, message: '생년월일(년도)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_mm: [
          { required: true, message: '생년월일(월)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_dd: [
          { required: true, message: '생년월일(일)을 입력하십시오.', trigger: 'change' }
        ],
        school_name: [
          { min: 2, max: 20, message: '최소 2자 이상 최대 20자까지 입력하십시오.' }
        ],
        class_seq: [
          { required: true, message: '클래스를 선택하십시오.', trigger: 'change' }
        ],
        msg_type: [
          { required: true, message: '알림 유형을 선택하십시오.', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    common.axios.post('/class/list/reg')
      .then(response => {
        const result = response.data
        result.forEach(c => {
          this.classData.push({label: c.class_name, value: c.class_seq})
        })
      })
    this.$nextTick(() => {
      this.retreive()
    })
  },
  computed: {
    getDays: {
      get: function () {
        return this.frm.birthday_mm !== '' ? this.getMonthLastDay(this.frm.birthday_yyyy + this.frm.birthday_mm) : 31
      }
    }
  },
  mounted () {
    const today = new Date()
    this.yearCount = (this.startYear - today.getFullYear()) * -1
  },
  methods: {
    retreive () {
      this.loadStoneDataTable('/user/request', this.search)
        .then(response => {
          // console.log('response.data : ', response.data)
          this.tableData = response.data
        })
    },
    handleSelectionChange (value) {
      this.handleSelection = value
    },
    multiAcceptUser () {
      if (this.handleSelection.length < 1) {
        return false
      }
      this.$confirm('가입을 승인하시겠습니까?', '', {
      }).then(() => {
        this.classficationFormData(this.handleSelection)
        common.axios.post('/user/accept', {userRequestInfo: this.handleSelection})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('가입이 승인되었습니다.')
              this.retreive()
            } else {
              this.$message.error(response.data.message)
            }
          })
          .catch(error => {
            if (error.response.data.errors) {
              error.response.data.errors.map(msg => {
                this.$message.error(msg)
              })
            }
          })
      }).catch(() => {
      })
    },
    multiDeleteUser () {
      if (this.handleSelection.length < 1) {
        this.$message.warning('삭제할 사용자를 선택하십시오.')
        return
      }
      this.$confirm('삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.post('/user/request/del', {userRequestInfo: this.handleSelection})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('삭제 되었습니다.')
              this.retreive()
            } else {
              this.$message.error(response.data.message)
            }
          })
          .catch(error => {
            if (error.response.data.errors) {
              error.response.data.errors.map(msg => {
                this.$message.error(msg)
              })
            }
          })
      }).catch(() => {
      })
    },
    classficationFormData (row) {
      row.forEach(item => {
        item.id = 'K' + this.getOnlyNumber(item.phone)
        item.school_name = item.school_name ? item.school_name : ''
      })
    },
    goEdit (row) {
      Object.keys(this.frm).forEach(key => {
        if (key === 'phone' || key.indexOf('birthday_') !== -1) {
          return true
        }
        this.frm[key] = this.isEmpty(row[key]) ? '' : row[key]
      })
      this.frm.birthday_yyyy = row.birthday.substr(0, 4)
      this.frm.birthday_mm = row.birthday.substr(4, 2)
      this.frm.birthday_dd = row.birthday.substr(6, 2)
      this.frm.phone = this.formatterPhone(row.phone)
      this.dialogVisible = true
    },
    getDateValue (value) {
      return (value < 10 ? '0' : '') + value
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.frm.birthday = this.frm.birthday_yyyy + this.frm.birthday_mm + this.frm.birthday_dd
          this.frm.phone = this.getOnlyNumber(this.frm.phone)
          common.axios.put('/user/join', this.frm)
            .then(response => {
              if (response.data.status === 1) {
                this.$message('수정되었습니다.')
                this.dialogVisible = false
                this.retreive()
              } else {
                this.$message.error(response.data.message)
              }
            })
            .catch(error => {
              if (error.response.data.errors) {
                error.response.data.errors.map(msg => {
                  this.$message.error(msg)
                })
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M991001.vue